var map = {
	"./Abhinav/loader.json": [
		39612,
		9612
	],
	"./Agrasen/loader.json": [
		59368,
		9368
	],
	"./Bhagini/loader.json": [
		32075,
		2075
	],
	"./Deogiri/loader.json": [
		61856,
		1856
	],
	"./JCOM/loader.json": [
		35672,
		5672
	],
	"./MOGAVEERA/loader.json": [
		40688,
		688
	],
	"./Mahesh/loader.json": [
		17603,
		7603
	],
	"./NCBM/loader.json": [
		71287,
		1287
	],
	"./Noble/loader.json": [
		30727,
		727
	],
	"./RSSB/loader.json": [
		35063,
		5063
	],
	"./Samta/loader.json": [
		60199,
		199
	],
	"./Satara/loader.json": [
		39919,
		9919
	],
	"./Sawji/loader.json": [
		38671,
		8671
	],
	"./Shriraksh/loader.json": [
		66670,
		6670
	],
	"./Suvarna/loader.json": [
		83495,
		3495
	],
	"./Ucob/loader.json": [
		44302,
		4302
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 72701;
module.exports = webpackAsyncContext;